import Vue from 'vue'
//import {any} from '@/bin/global.extend'
import Router from 'vue-router'
import pageRouter from './RouterRegistry';

Vue.use(Router);

let _routers: any[] = [];
for(let key in pageRouter){
	let currentRouter:any = pageRouter[key];
	_routers.push({
		path: currentRouter.path,
		component: currentRouter.component,
		name: currentRouter.name,
		children: currentRouter.children || [],
		redirect: currentRouter.redirect,
		beforeEnter: currentRouter.beforeEnter,
		meta: currentRouter?.meta || {},
		mate:{
			requiresAuth: currentRouter.mate != "none"  //需要登录验证
		}
	})
}
export default new Router({
	mode: 'hash',
	// mode:'history',
	routes: _routers
})
